export const TOPBAR_HEIGHT = 52;
export const IMPERSONATE_BANNER_HEIGHT = 48;
export const USERMANAGEMENT_BANNER_HEIGHT = 64;
